export default () => {
    const checkout = document.querySelector('.customCheckoutPage');
    if (!checkout) return;

    initializeCheckoutNotifications();
    initializeLoginToggle();
    initializeCustomFieldsValidation();
}

const initializeLoginToggle = () => {
    const toggle = document.querySelector('.customCheckoutPage__toggle-item');
    const loginForm = document.querySelector('.woocommerce-form-login');

    if (!toggle || !loginForm) return;

    toggle.addEventListener('click', () => {
        if (loginForm.style.display === 'none') {
            loginForm.style.display = 'flex';
        } else {
            loginForm.style.display = 'none';
        }
    });
}

const initializeCheckoutNotifications = () => {
    // jQuery(document.body).on('checkout_error', (e, errors) => {
    //     fireNotification({
    //         icon: 'error',
    //         title: 'Błąd',
    //         html: errors,
    //         timer: 5000
    //     })
    // });
}

const addInlineMessages = () => {
    let woocommerceErrorsEl = jQuery('.woocommerce-error');
    let woocommerceInlineErrorsEl = jQuery('li[data-error-for]', woocommerceErrorsEl);
    let inlineErrorMessagesEl = jQuery('.js-custom-error-message');

    // as we use ajax submitting hide old validation messages
    if(inlineErrorMessagesEl.length) {
        inlineErrorMessagesEl.hide();
    }

    if(woocommerceInlineErrorsEl.length) {
        woocommerceInlineErrorsEl.each(function () {
            let errorEl = jQuery(this);
            let errorText = jQuery.trim(errorEl.text());

            let targetFieldId = errorEl.data('error-for');

            if(errorText && targetFieldId) {
                let targetFieldEl = jQuery('#' + targetFieldId);
                let errorMessageField = jQuery('.js-custom-error-message', targetFieldEl);

                if(targetFieldEl.length && errorMessageField.length) {
                    targetFieldEl.removeClass('woocommerce-validated');
                    targetFieldEl.addClass('woocommerce-invalid');

                    errorMessageField.text(errorText);
                    errorMessageField.show();
                    errorEl.hide();
                }
            }
        });

        if(woocommerceInlineErrorsEl.filter(':visible').length === 0) {
            woocommerceErrorsEl.hide();
        } else {
            $('li:not([data-error-for])', woocommerceErrorsEl).hide();
        }
    }
}

const initializeCustomFieldsValidation = () => {
    function check_nip_sum(nip) {
        if(typeof nip !== 'string')
            return false;

        nip = nip.replace(/[\ \-]/gi, '');

        let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let controlNumber = parseInt(nip.substring(9, 10));
        let weightCount = weight.length;
        for (let i = 0; i < weightCount; i++) {
            sum += (parseInt(nip.substr(i, 1)) * weight[i]);
        }

        return sum % 11 === controlNumber;
    }

    jQuery(function($){

        $('body').on('blur change', "#billing_company", function() {
            const isChecked = jQuery('#invoice-button').is(':checked');
            const companyField = jQuery('#billing_company').closest('.form-row');
            const companyInput = jQuery('#billing_company');
            const isEmpty = companyInput.val().trim().length === 0;
            
            if (isChecked && isEmpty) {
                companyField.addClass('woocommerce-invalid');
                companyField.removeClass('woocommerce-validated');
                companyInput.prop('required', true);
            } else if (isChecked && !isEmpty) {
                companyField.removeClass('woocommerce-invalid');
                companyField.addClass('woocommerce-validated');
                companyInput.prop('required', true);
            } else {
                companyField.removeClass('woocommerce-invalid woocommerce-validated');
                companyInput.prop('required', false);
            }
        });

        $('body').on('blur change', "#billing_nip", function() {
            const wrapper = $(this).closest( '.form-row' );

            const nip = $(this).val();
            if(nip.length === 0 || !check_nip_sum(nip)) {
                wrapper.addClass( 'woocommerce-invalid' );
                wrapper.removeClass( 'woocommerce-validated' );
            } else {
                wrapper.removeClass( 'woocommerce-invalid' );
                wrapper.addClass( 'woocommerce-validated' );
            }
        });

        $(document.body).on('updated_checkout', function() {
            addInlineMessages();
        });

        $(document.body).on('checkout_error', function (event) {
            $('html, body').stop();

            addInlineMessages();
        });

        $('#invoice-button').on('click', function() {
            checkNipField(this);
        });
        checkNipField('#invoice-button');
    });

    const checkNipField = (element) => {
        if(jQuery(element).is(':checked')) jQuery('.hide-invoice-field').slideDown();
        else jQuery('.hide-invoice-field').slideUp();
        jQuery('#billing_nip').prop('required', jQuery(element).is(':checked'));
        jQuery('#billing_company').prop('required', jQuery(element).is(':checked'));
        jQuery(element).val(jQuery(element).is(':checked') ? 1 : 0);
    }
}